import { createContext } from 'react';

export type AlertType = 'success' | 'info' | 'error';

export interface Alert {
  type: AlertType;
  message: string;
}

export interface Context {
  alert: Alert | null;
  displayAlert: (alert: Alert) => void;
}

const AlertContext = createContext<Context>({
  alert: null,
  displayAlert: () => {},
});

export default AlertContext;
